import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f9b8603"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "careersheet_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "careersheet_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_title_text" }, "社会人経験の編集")
], -1))
const _hoisted_3 = { class: "careersheet_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "就業状況"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_5 = { class: "careersheet_input_layout_column_2" }
const _hoisted_6 = { class: "careersheet_input" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "経験社数"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_8 = { class: "careersheet_input_layout_column_2" }
const _hoisted_9 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_10 = { class: "careersheet_input_layout_column_2_item_inner" }
const _hoisted_11 = { class: "careersheet_input_layout_column_2_item_inner_select" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_input_layout_column_2_item_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_input_layout_column_2_item_inner_suffix_text" }, "社")
], -1))
const _hoisted_13 = { class: "careersheet_input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "社会人経験年数"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_15 = { class: "careersheet_input_layout_column_2" }
const _hoisted_16 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_17 = { class: "careersheet_input_layout_column_2_item_inner" }
const _hoisted_18 = { class: "careersheet_input_layout_column_2_item_inner_select" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_input_layout_column_2_item_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_input_layout_column_2_item_inner_suffix_text" }, "年")
], -1))
const _hoisted_20 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_21 = { class: "careersheet_input_layout_column_2_item_inner" }
const _hoisted_22 = { class: "careersheet_input_layout_column_2_item_inner_select" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "careersheet_input_layout_column_2_item_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_input_layout_column_2_item_inner_suffix_text" }, "ヵ月")
], -1))
const _hoisted_24 = { class: "careersheet_input" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "マーケティング・デジタル・クリエイティブ領域の経験"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "広告、マーケティング、コンサル、広報・PR、販売促進・SP、印刷、デジタルマーケティング、Web制作、CM・映像、デザイン、コピー、編集・ライティングなど")
], -1))
const _hoisted_26 = { class: "careersheet_input_layout_column_2" }
const _hoisted_27 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_28 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_29 = { class: "careersheet_input" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "ポートフォリオサイトのURL")
], -1))
const _hoisted_31 = { class: "careersheet_input_layout_column_1" }
const _hoisted_32 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_33 = { class: "careersheet_input_layout_column_1_item_inner" }
const _hoisted_34 = { class: "careersheet_input_layout_column_1_item_inner_select" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "※ポートフォリオサイトをお持ちの方はこちらにURLを入力してください")
], -1))
const _hoisted_36 = { class: "careersheet_input" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "ポートフォリオサイトのID")
], -1))
const _hoisted_38 = { class: "careersheet_input_layout_column_1" }
const _hoisted_39 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_40 = { class: "careersheet_input_layout_column_1_item_inner" }
const _hoisted_41 = { class: "careersheet_input_layout_column_1_item_inner_select" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "※ポートフォリオサイトにIDが付いている場合はこちらに入力してください")
], -1))
const _hoisted_43 = { class: "careersheet_input" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "ポートフォリオサイトのパスワード")
], -1))
const _hoisted_45 = { class: "careersheet_input_layout_column_1" }
const _hoisted_46 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_47 = { class: "careersheet_input_layout_column_1_item_inner" }
const _hoisted_48 = { class: "careersheet_input_layout_column_1_item_inner_select" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "※ポートフォリオサイトにパスワードが付いている場合はこちらに入力してください")
], -1))
const _hoisted_50 = { class: "careersheet_button" }
const _hoisted_51 = { class: "careersheet_button_prev" }
const _hoisted_52 = { class: "careersheet_button_next" }

import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import { computed } from 'vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { MasterDataWkStatus } from '@/api/masterDataEndpoint';
import { useRouter, useRoute } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { validationRuleHelper } from '@/utils/validationRule';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeEditView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { meta } = useForm();

const { value: expcompNum, errors: expcompNumErrors } = useField<string>(
  'expcompNum',
  validationRuleHelper({ required: true, numeric: true }),
  {
    initialValue: store.getters['resumeCompany/expcompNum'],
    bails: false,
    label: '経験社数',
  }
);

const { value: expYearNum, errors: expYearNumErrors } = useField<string>(
  'expYearNum',
  validationRuleHelper({ required: true, betweenValue: [0, 99] }),
  {
    initialValue: store.getters['resumeCompany/expYearNum'],
    bails: false,
    label: '経験年数(年)',
  }
);

const { value: expMonthNum, errors: expMonthNumErrors } = useField<string>(
  'expMonthNum',
  validationRuleHelper({ required: true, betweenValue: [0, 12] }),
  {
    initialValue: store.getters['resumeCompany/expMonthNum'],
    bails: false,
    label: '経験年数(月)',
  }
);

const expNumErrors = computed(() => {
  return Array.from(new Set([expYearNumErrors.value, expMonthNumErrors.value].flat()));
});

const { value: adlandexpFlg, errors: adlandexpFlgErrors } = useField<boolean | null>(
  'adlandexpFlg',
  validationRuleHelper({ required: true }),
  {
    initialValue: store.getters['resumeCompany/adlandexpFlg'],
    bails: false,
    label: '業界経験',
  }
);

const { value: wkStatusId, errors: wkStatusIdErrors } = useField<number | null>('wkStatusId', validationRuleHelper({ required: true }), {
  initialValue: store.getters['resumeCompany/wkStatusId'],
  bails: false,
  label: '就業状況',
});

const { value: wkStatusArray } = useField<MasterDataWkStatus[]>('wkStatusArray', undefined, {
  initialValue: store.getters['resumeCompany/wkStatusArray'],
  bails: false,
  label: '就業状況',
});

const { value: portfolioSiteUrl, errors: portfolioSiteUrlErrors } = useField<string | null>('portfolioSiteUrl', validationRuleHelper({ han_eisuu_kigou: true,max: 200 }), {
  initialValue: store.getters['resumeCompany/portfolioSiteUrl'] !== "null" ? store.getters['resumeCompany/portfolioSiteUrl'] : '',
  bails: false,
  label: 'ポートフォリオサイトのURL',
});

const { value: portfolioSiteId, errors: portfolioSiteIdErrors } = useField<string | null>('portfolioSiteId', validationRuleHelper({ han_eisuu_kigou: true,max: 20 }), {
  initialValue: store.getters['resumeCompany/portfolioSiteId'] !== "null" ? store.getters['resumeCompany/portfolioSiteId'] : '',
  bails: false,
  label: 'ポートフォリオサイトのID',
});

const { value: portfolioSitePass, errors: portfolioSitePassErrors } = useField<string | null>('portfolioSitePass', validationRuleHelper({ han_eisuu_kigou: true,max: 20 }), {
  initialValue: store.getters['resumeCompany/portfolioSitePass'] !== "null" ? store.getters['resumeCompany/portfolioSitePass'] : '',
  bails: false,
  label: 'ポートフォリオサイトのパスワード',
});

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e30', query: { ref: 'e' } });
  } else {
    router.push({ name: 'n30' });
  }
};

const transitionConfirmPage = () => {
  const value = {
    expcompNum: expcompNum.value,
    expYearNum: expYearNum.value,
    expMonthNum: expMonthNum.value,
    adlandexpFlg: adlandexpFlg.value,
    wkStatusId: wkStatusId.value,
    portfolioSiteUrl: portfolioSiteUrl.value,
    portfolioSiteId: portfolioSiteId.value,
    portfolioSitePass: portfolioSitePass.value,
  };
  store.commit('resumeCompany/set', value);
  if (route.query.ref === 'e') {
    router.push({ name: 'e32', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e32' });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wkStatusArray), (wkStatus) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "careersheet_input_layout_column_2_item",
            key: wkStatus.code
          }, [
            _createVNode(BaseRadioButton, {
              name: "wkStatus",
              label: wkStatus.name,
              value: wkStatus.code,
              modelValue: _unref(wkStatusId),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(wkStatusId) ? (wkStatusId).value = $event : null))
            }, null, 8, ["label", "value", "modelValue"])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(ErrorMessage, { errors: _unref(wkStatusIdErrors) }, null, 8, ["errors"]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(BaseTextForm, {
                placeholder: "2",
                maxlength: 2,
                modelValue: _unref(expcompNum),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(expcompNum) ? (expcompNum).value = $event : null))
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_12
          ])
        ])
      ])
    ]),
    _createVNode(ErrorMessage, { errors: _unref(expcompNumErrors) }, null, 8, ["errors"]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(BaseTextForm, {
                placeholder: "6",
                maxlength: 2,
                modelValue: _unref(expYearNum),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(expYearNum) ? (expYearNum).value = $event : null))
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_19
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(BaseTextForm, {
                placeholder: "6",
                maxlength: 2,
                modelValue: _unref(expMonthNum),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(expMonthNum) ? (expMonthNum).value = $event : null))
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_23
          ])
        ])
      ])
    ]),
    _createVNode(ErrorMessage, { errors: _unref(expNumErrors) }, null, 8, ["errors"]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(BaseRadioButton, {
            label: "あり",
            value: true,
            modelValue: _unref(adlandexpFlg),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(adlandexpFlg) ? (adlandexpFlg).value = $event : null))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(BaseRadioButton, {
            label: "なし",
            value: false,
            modelValue: _unref(adlandexpFlg),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(adlandexpFlg) ? (adlandexpFlg).value = $event : null))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createVNode(ErrorMessage, { errors: _unref(adlandexpFlgErrors) }, null, 8, ["errors"]),
    _createElementVNode("div", _hoisted_29, [
      _hoisted_30,
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(BaseTextForm, {
                maxlength: 200,
                modelValue: _unref(portfolioSiteUrl),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(portfolioSiteUrl) ? (portfolioSiteUrl).value = $event : null))
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(ErrorMessage, { errors: _unref(portfolioSiteUrlErrors) }, null, 8, ["errors"]),
    _hoisted_35,
    _createElementVNode("div", _hoisted_36, [
      _hoisted_37,
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(BaseTextForm, {
                maxlength: 20,
                modelValue: _unref(portfolioSiteId),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(portfolioSiteId) ? (portfolioSiteId).value = $event : null))
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(ErrorMessage, { errors: _unref(portfolioSiteIdErrors) }, null, 8, ["errors"]),
    _hoisted_42,
    _createElementVNode("div", _hoisted_43, [
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createVNode(BaseTextForm, {
                maxlength: 20,
                modelValue: _unref(portfolioSitePass),
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(portfolioSitePass) ? (portfolioSitePass).value = $event : null))
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(ErrorMessage, { errors: _unref(portfolioSitePassErrors) }, null, 8, ["errors"]),
    _hoisted_49,
    _createElementVNode("div", _hoisted_50, [
      _createElementVNode("div", _hoisted_51, [
        _createVNode(BaseButton, {
          theme: "tertiary",
          type: "button",
          onClick: transitionPreviousPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("戻る")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createVNode(BaseButton, {
          theme: "primary",
          type: "button",
          disabled: !_unref(meta).valid,
          onClick: transitionConfirmPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("確認する")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})